var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.types,"loading":_vm.loading,"hint":_vm.hint,"persistent-hint":""},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("label",[_vm._v("Enum Selector")])]},proxy:true},{key:"message",fn:function(ref){
var key = ref.key;
var message = ref.message;
return [_c('span',{key:key,domProps:{"innerHTML":_vm._s(message)}})]}}],null,true),model:{value:(_vm.localType),callback:function ($$v) {_vm.localType=$$v},expression:"localType"}})}
var staticRenderFns = []

export { render, staticRenderFns }